import React from "react";
import { Controller } from "react-hook-form";
import {IDaHiddenFieldProps} from "./types";

export const DaHiddenField: React.FC<IDaHiddenFieldProps<any>> = (
    {
        control,
        name,
        defaultValue="",
        errors,
    }: IDaHiddenFieldProps<any>
) => {

  return (
      <Controller
          name={name}
          control={control}
          render={({ field }) =>
              <input
                  {...field}
                  type={"hidden"}
                  value={field.value}
                  onChange={field.onChange}
                  // defaultValue={defaultValue}
              />
          }
      />
  );
};